import React, { useContext, useEffect, useState } from "react";
import InputForm from "../../../Components/InputForm/InputForm";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import DateForm from "../../../Components/DateForm/DateForm";
import { LoaderContext } from "../../../Helpers/Context/Context";
import { useLocation } from "react-router-dom";
import notify from "../../../Helpers/ToastNotification";
import { APICall, HttpMethod } from "../../../Helpers/Network/APICalls";
import { getPersonalDetailsByMemberId } from "../../../Helpers/APIEndPoints/EndPoints";
import moment from "moment";
import { truncate } from "fs";
import { GetDecryptedMemberIdFromLocalStorage } from "../../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { Decrypt } from "../../../Helpers/Cryptography/Crypto";
const PersonalDetails = (props) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  // const memberid = GetDecryptedMemberIdFromLocalStorage() || "";
  const { state } = useLocation();
  const location = useLocation();
  // let memberid = state.id ? state.id : "";

  const [data, setData] = React.useState({
    tokenNumber: null,
    typeOfApplicant: null,
    firstName: "",
    middleName: "",
    lastName: "",
    dob: null,
    doj: null,
    doc: null,
    mobileNumber: null,
    email: "",
    address: "",
    GenderName: "",
    MaritialStatusName: "",
    BirthCity: "",
    NationalityName: "",
    ReligionName: "",
    AddLineSecond: "",
    PostalCode: "",
    District: "",
    RegionName: "",
    CountryName: "",
    ActualServiceYears: "",
    CareOf: "",
    Street: "",
    StateName: "",
    TitleName: "",
  });

  const [error, setError] = React.useState<any>({});

  const TypeofApplicantDropDownData = [
    { value: 1, label: "Officers, M&M and Core Users (Mahindra)" },
    { value: 2, label: "Associates & Others" },
  ];

  const tabsData = TypeofApplicantDropDownData;

  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };

  const getPersonalDetailsByIdApiCall = async (memberid: any) => {
    showLoader();

    // let param = `${getPersonalDetailsByMemberId}/${id}`;

    // const res = await APICall(param, {}, HttpMethod.GET);

    let requestParams = { MemberId: memberid };
    const res = await APICall(getPersonalDetailsByMemberId, requestParams);

    if (res.Message === "Ok" && res.Data !== null) {
      let data = {
        tokenNumber: Number(res.Data.TokenNo),
        typeOfApplicant: tabsData.find((d) => d.value === res.Data.ApplicantType),
        firstName: res.Data.FirstName,
        middleName: res.Data.MiddleName,
        lastName: res.Data.LastName,
        dob: moment(res.Data.DOB, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
        doj: moment(res.Data.DOJ, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
        doc: moment(res.Data.DOC, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
        mobileNumber: Number(res.Data.ContactNo),
        email: res.Data.EmailId,
        address: res.Data.Address,
        GenderName: res?.Data?.GenderName,
        MaritialStatusName: res?.Data?.MaritialStatusName,
        BirthCity: res?.Data?.BirthCity,
        NationalityName: res?.Data?.NationalityName,
        ReligionName: res?.Data?.ReligionName,
        AddLineSecond: res?.Data?.AddLineSecond,
        PostalCode: res?.Data?.PostalCode,
        District: res?.Data?.District,
        RegionName: res?.Data?.RegionName,
        CountryName: res?.Data?.CountryName,
        ActualServiceYears: res?.Data.ActualServiceYears,
        CareOf: res?.Data.CareOf,
        Street: res?.Data.Street,
        StateName: res?.Data.StateName,
        TitleName: res?.Data.TitleName,
      };

      setData(data);
      hideLoader();
    } else {
      notify(1, "Data not found");
      hideLoader();
    }
  };

  useEffect(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      if (params.has("memberid")) {
        let encMemberId = params.get("memberid");
        // let memberid = decodeURIComponent(Decrypt(encMemberId));
        let decodeURLMember = decodeURIComponent(Decrypt(encMemberId));
        const parts = decodeURLMember.split("||");
        let memberid = parts[0];
        onLoadApiCall(memberid);
      }
    }
  }, [location.search]);

  const onLoadApiCall = async (memberid) => {
    showLoader();

    if (memberid != null && memberid != "") {
      await getPersonalDetailsByIdApiCall(memberid);
    } else {
      notify(1, "Something went wrong");
    }

    hideLoader();
  };

  return (
    <div className="">
      <div className="col-lg-12 col-md-12 ">
        <div className="row" style={{ marginLeft: "-15px", marginRight: "-15px" }}>
         
          <div
            className="col-lg-12 col-sm-12 col-xs-12 "
            style={{
              marginTop: "15px",
              background: "#F6ECED",
              padding: "15px",
              margin: "0 auto",
            }}
          >
            <div className="form-group col-lg-4 col-sm-4 col-xs-4 p-1" style={{ margin: "0 auto"}}>
              <label>Token Number</label>
              <sup>*</sup>
              <InputForm placeholder={""} value={data.tokenNumber} maxlength="10" isDisabled={true} type="number" onWheel={(e) => e.target.blur()} />
              {error[data.tokenNumber] && <p style={{ color: "red" }}>{error[data.tokenNumber]}</p>}
            </div>
          </div>
          </div>
          <div className="row" style={{ marginLeft: "-30px", marginRight: "-30px" }} >
          <div className="col-lg-4 col-sm-4 col-xs-4">
            <div className="form-group"></div>
            <label>Type of Applicant</label>
            <sup>*</sup>
            <SelectForm
              value={data.typeOfApplicant}
              isDisabled={true}
              placeholder="Type Of Applicant"
              options={tabsData}
              onChange={(val: any) => onChange("typeOfApplicant", val)}
            />
            {error[data.typeOfApplicant] && <p style={{ color: "red" }}>{error[data.typeOfApplicant]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Title</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.TitleName} isDisabled={true} />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>First Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.firstName}
              isDisabled={true}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("firstName", value);
              }}
            />
            {error[data.firstName] && <p style={{ color: "red" }}>{error[data.firstName]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Middle Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.middleName}
              isDisabled={true}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("middleName", value);
              }}
            />
            {error[data.middleName] && <p style={{ color: "red" }}>{error[data.middleName]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Last Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.lastName}
              isDisabled={true}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("lastName", value);
              }}
            />
            {error[data.lastName] && <p style={{ color: "red" }}>{error[data.lastName]}</p>}
          </div>

          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Gender</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.GenderName} isDisabled={true} />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Date Of Birth</label>
            <sup>*</sup>
            <DateForm isDisabled={true} value={data.dob} onChange={(val: any) => onChange("dob", val)} placeholder="DD-MM-YYYY" />
            {error[data.dob] && <p style={{ color: "red" }}>{error[data.dob]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Maritial Status</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.MaritialStatusName} isDisabled={true} />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Place of Birth</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.BirthCity} isDisabled={true} />
          </div>

          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>State</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.StateName} isDisabled={true} />
          </div>

          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Nationality</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.NationalityName} isDisabled={true} />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Religion</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.ReligionName} isDisabled={true} />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Date of Joining</label>
            <sup>*</sup>
            <DateForm isDisabled={true} value={data.doj} onChange={(val: any) => onChange("doj", val)} placeholder="DD-MM-YYYY" />
            {error[data.doj] && <p style={{ color: "red" }}>{error[data.doj]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Actual Year of Service</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.ActualServiceYears} isDisabled={true} />
          </div>

          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Care Of</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.CareOf} isDisabled={true} />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Street/House</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.Street} isDisabled={true} />
          </div>

          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>2nd Line</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.AddLineSecond} isDisabled={true} />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Postal Code</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.PostalCode} isDisabled={true} />
          </div>

          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>District</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.District} isDisabled={true} />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Region</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.RegionName} isDisabled={true} />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Country</label>
            <sup>*</sup>
            <InputForm placeholder={""} value={data.CountryName} isDisabled={true} />
          </div>

          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Date of Confirmation</label>
            <sup>*</sup>
            <DateForm isDisabled={true} value={data.doc} onChange={(val: any) => onChange("doc", val)} placeholder="DD-MM-YYYY" />
            {error[data.doc] && <p style={{ color: "red" }}>{error[data.doc]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Mobile Number</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.mobileNumber}
              isDisabled={true}
              onChange={(val: any) => {
                let value = val.target.value;
                const regex = /^[0-9\b]/;
                if (value === "" || regex.test(value)) {
                  if (value.length > 10) {
                    value = value.slice(0, 10);
                  }
                  onChange("mobileNumber", value);
                }
              }}
              type="number"
              onWheel={(e) => e.target.blur()}
            />
            {error[data.mobileNumber] && <p style={{ color: "red" }}>{error[data.mobileNumber]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Email Id</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.email}
              isDisabled={true}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("email", value);
              }}
            />
          </div>
         
          {/* <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Address</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.address}
              isDisabled={true}
              textArea={true}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("address", value);
              }}
            />
            {error[data.address] && (
              <p style={{ color: "red" }}>{error[data.address]}</p>
            )}
          </div> */}
        </div>
      </div>
      {/* <div className="p-2 d-flex justify-content-end" style={{ marginTop: 50 }}>
        <ButtonComponent  icon={"fas fa-arrow-right"} value={"Save & Next" } style={{marginLeft:"10px"}}  id={"saveBtn"} onClick={onSubmit}/>
      </div> */}
    </div>
  );
};

export default PersonalDetails;
